import { getCtData, setData } from '../project';

// F2 - setTimeOut (newBase)
type Tprops_F2 = { pass: { A: any; B: any; C: any } };
export const F2 =
  (props: Tprops_F2) =>
  async (...args: any) => {
    const { A, B, C } = props.pass;

    // ---------- set Caps Inputs
    // let pathTimeout = "!#!path timeout cash!#!";
    // let timeMiliSec = "!#!miliseconds value!#!";
    // const funcsDelay = [!#!functions to execute on delay!#!];
    const timeID = getCtData(A);
    if (timeID) clearTimeout(timeID);

    const fnGroup = async () => {
      // console.log('timeout exec func', args);
      for (const currFunc of C) await currFunc(args[0]);
    };

    const newTimeID = setTimeout(fnGroup, Number(B));
    setData({ path: A, value: newTimeID });
  };
